// 自定义配置

/**
 * @zh_CN 登录页面 url 地址
 */
export const LOGIN_PATH = '/home';
